/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { isEmpty } from '../helper/is-empty.helper';
import { isNumber } from '../helper/is-number.helper';
import { CoreErrorKey } from '../key/core-error.key';
import { ApplicationError } from '../model/application-error.model';

export interface TypeValidationOptions {
  type: string;
  strict?: boolean;
}

export function validateType(value: any, options: TypeValidationOptions | string): boolean {
  if (isEmpty(value)) {
    return true;
  }
  if (!options) {
    throw new ApplicationError({
      key: CoreErrorKey.VALIDATION_OPTIONS_MISSING,
      message: 'Validation options missing'
    });
  }
  let type: string;
  let strict: boolean;
  if (typeof options === 'object') {
    type = options.type;
    strict = options.strict !== undefined ? options.strict : true;
  } else if (typeof options === 'string') {
    type = options;
    strict = true;
  }
  if (!type) {
    throw new ApplicationError({
      key: CoreErrorKey.VALIDATION_OPTIONS_INVALID,
      arguments: { options },
      message: 'Validation options invalid'
    });
  }
  return typeof value === type || !strict && type === 'number' && isNumber(value);
}
